import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelectedStudents } from '../hooks/use-selected-students';

export const CandidateCheckbox = ({ student }) => {
    const { isStudentSelected, toggleStudentSelection } = useSelectedStudents();
    return (
        <Form.Check
            type='checkbox'
            size='sm'
            checked={isStudentSelected(student)}
            onChange={(e) => toggleStudentSelection(student, e.target.checked)}
        />
    );
};
